<div class="_calendar-desktop-page" [ngClass]="{'_expand-filters': expandFilters}">

    <div class="_right-calendar-headers" [ngClass]="{'_has-filters': false}">	
		<ng-container *ifUserHasPermissions="[UserPermissions.WriteEvents]">
			<button type="button" class="_button _add-button" (click)="controller.showEventDetails()">
				<ion-icon src="./assets/icons/add-outline.svg"></ion-icon>
				<span [translate]="'EVENT.CREATE'"></span>
			</button>
		</ng-container>
		
		<button type="button" (click)="controller.getDisplayCalendarEvents()" class="_button _refresh-button">
			<ion-icon name="refresh"></ion-icon>
		</button>
	</div>

	<div class="_filters" >    
		<button type="button" (click)="toggleFilters()" class="_button _filter-button">
			<ion-icon name="filter-outline"></ion-icon>
			
			<span [translate]="'FILTERS.COLLAPSE'" *ngIf="expandFilters; else collapse"></span>
			<ng-template #collapse>
				<span [translate]="'FILTERS.EXPAND'"></span>
			</ng-template>

			<ion-icon class="_filtering" *ngIf="controller.filtering" src="./assets/icons/present-outline.svg">
			</ion-icon>
		</button>

		

		<div class="_filters-container">
			<calendar-address-filter (filter)="onAddressFilter($event)"></calendar-address-filter>
			<calendar-input-filter-component translationKey="SEARCH_TERM" (filter)="onSearchTermFilter($any($event))"></calendar-input-filter-component>
			<calendar-select-filter-component translationKey="EVENT_TYPES" (filter)="onEventTypeFilter($any($event))" [input]="eventTypes" [useTranslation]="false"></calendar-select-filter-component>
			<calendar-select-filter-component translationKey="DIGIBANK_AGENCIES" (filter)="onDigibankAgencyFilter($any($event))" [input]="digibankAgencies" [useTranslation]="false"></calendar-select-filter-component>		
			<calendar-select-filter-component translationKey="SHOW_BEEGO" (filter)="onShowBeegoFilter($any($event))" [input]="showBeegoOptions" [multiple]="false"></calendar-select-filter-component>

			<div class="_spacer"></div>

			<div class="_info _warning" *ngIf="controller.beegoStudentsAreMissing">
				<img src="./assets/BEEGO_logo.png" width="58px" height="39px" />
				<p [innerHTML]="'BEEGO_APPOINTMENT.NO_BEEGO_STUDENTS' | translate"></p>
			</div>

			<div class="_info _warning" *ngIf="controller.beegoNoPartnerLink">
				<img src="./assets/BEEGO_logo.png" width="58px" height="39px" />
				<p [innerHTML]="'BEEGO_APPOINTMENT.NO_PARTNER_LINK' | translate"></p>
			</div>

			<div class="_info _message" *ngIf="controller.firstBeegoStudentDate">
				<img src="./assets/BEEGO_logo.png" width="58px" height="39px" />
				<p [innerHTML]="'BEEGO_APPOINTMENT.FIRST_BEEGO_STUDENT' | translate:{date: controller.firstBeegoStudentDate}"></p>
			</div>

			<div class="_info" *ngIf="!controller.beegoStudentsAreMissing && !controller.firstBeegoStudentDate && !controller.beegoNoPartnerLink">
				<img src="./assets/BEEGO_logo.png" width="58px" height="39px" />
				<p  [translate]="'BEEGO_APPOINTMENT.BEEGO_FILTER_INFO'"></p>
			</div>

		</div>

	</div>

	<calendar-desktop-component
		[events]="$any(controller.events)"
		[refresh]="controller.refresh"
		[viewDate]="controller.viewDate"
		[showFilters]="true"
		[view]="controller.view"
		[showViewSelection]="true"
		[translations]="controller.translations"
		(viewDateChanged)="controller.onViewDateChanged($any($event))"
		(viewChanged)="controller.onViewChanged($any($event))"
		(eventClick)="controller.onEventClick($any($event))"
		(eventDrag)="controller.onEventDrag($any($event))"
		(dayChanged)="controller.onDayChanged($any($event))"
		(hourSegmentClick)="controller.onHourSegmentClick($any($event))"
		[weekEventTemplate]="eventTemplate"
		[dayEventTemplate]="eventTemplate"
	>
	</calendar-desktop-component>

	<ng-template
      #eventTemplate
      let-weekEvent="weekEvent"
    >
		<div
		class="cal-event"
		[ngStyle]="{
			backgroundColor: weekEvent.event.color?.secondary,
			borderColor: weekEvent.event.color?.primary,
			background: weekEvent.event.isInFuture ? weekEvent.event.color?.primary: 'repeating-linear-gradient(45deg,' + weekEvent.event.color?.primary + ',' + weekEvent.event.color?.primary + ' 10px,#dedede 10px,#dedede 20px)'
		}"
		(click)="controller.onEventClick({click: $any($event), event: weekEvent.event})"
		tabindex="0"
		role="application"
		tooltip="{{weekEvent.event.title}}"
		[options]="{ 'hide-delay': 0, theme: 'dark', tooltipClass: '_tooltip _calendar' }"
		>
			<span [innerHTML]="weekEvent.event.title"></span>
		</div>
    </ng-template>

</div>